export const commonEnv = {
  appVersion: '4.5.1',
  appVersionCode: 100110274,
  firebaseAppIdIOS: '1:1018418760703:ios:24f2e02e07f4645c4af5ca',
  firebaseAppIdAndroid: '1:1018418760703:android:00468aa3381469164af5ca',
  firebaseAppIdWeb: '1:1018418760703:web:b08f2f46130910a54af5ca',
  firebase: {
    apiKey: 'AIzaSyCv7aFStwW6QMt5mK8HtvBiVzCHOABWza4',
    authDomain: 'push-estudaqui.firebaseapp.com',
    databaseURL: 'https://push-estudaqui.firebaseio.com',
    projectId: 'push-estudaqui',
    storageBucket: 'push-estudaqui.firebasestorage.app',
    messagingSenderId: '1018418760703',
    appId: '1:1018418760703:web:b08f2f46130910a54af5ca',
    measurementId: 'G-S1FVN0QVWT'
  },
  googleClientId: '1018418760703-bvq9453ifqs8m31svtehcnn6rpqup85h.apps.googleusercontent.com',
  facebookAppId: '405977553999839'
};
